import {objetos} from 'lib.front';
import {cmps} from './constantes';

export const esquemaCampos = {
   [cmps.CODIGO]: {valor: null, error: ''},
   [cmps.DENOMINACION]: {valor: '', error: ''},
   [cmps.ESTADO]: {valor: 0, error: ''}
};

export const esquemaValidacion = {
   [cmps.CODIGO]: {
      requerido: true
   },
   [cmps.DENOMINACION]: {
      requerido: true
   },
   [cmps.ESTADO]: {
      requerido: false
   }
};

export const esquemaQuery = [
   new objetos.oCampo(cmps.CODIGO, 'String!', true, true, true, true),
   new objetos.oCampo(cmps.DENOMINACION, 'String', true, false, true, true),
   new objetos.oCampo(cmps.ESTADO, 'Int', true, false, true, true)
];
